export enum Tenant {
  BonlivaAB = "bonliva-ab",
  WCC = "wcc"
}
